var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdeaShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4252 8.84052C19.0197 9.13544 18.7143 9.57378 18.7143 10.0725C18.7143 10.4241 18.4268 10.7091 18.0722 10.7091H15.9278C15.5732 10.7091 15.2857 10.4241 15.2857 10.0725C15.2857 9.57378 14.9803 9.13544 14.5748 8.84052C13.6176 8.14435 13 7.046 13 5.81025C13 3.70591 14.7909 2 17 2C19.2091 2 21 3.70591 21 5.81025C21 7.046 20.3824 8.14435 19.4252 8.84052Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8571 11.725C15.4707 11.725 15.1574 12.0357 15.1574 12.419C15.1574 12.8022 15.4707 13.1129 15.8571 13.1129H18.1429C18.5293 13.1129 18.8426 12.8022 18.8426 12.419C18.8426 12.0357 18.5293 11.725 18.1429 11.725H15.8571Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.111 21.326C14.6039 22.1703 11.9057 22.2214 9.37549 21.4792C9.45629 21.2309 9.5 20.9655 9.5 20.6899V15.6386C9.5 15.3875 9.46373 15.1449 9.39619 14.916C11.2132 14.4113 13.1183 14.3115 14.9795 14.6249L15.549 14.7207C16.317 14.8501 16.8929 15.3965 17.1179 16.0748L14.7437 16.947C14.3544 17.09 14.1536 17.5248 14.2952 17.918C14.4367 18.3113 14.867 18.5142 15.2563 18.3712L17.6228 17.5018L19.9824 16.9058C21.0073 16.647 22 17.4301 22 18.4973C22 19.2034 21.5528 19.8302 20.8897 20.0535L17.111 21.326Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 14.6283C2.44772 14.6283 2 15.0806 2 15.6386V20.6899C2 21.2478 2.44772 21.7002 3 21.7002H7C7.55228 21.7002 8 21.2478 8 20.6899V15.6386C8 15.0806 7.55228 14.6283 7 14.6283H3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaShare);
export default __webpack_public_path__ + "static/media/idea-share.df4494dfe68c9a7c2eae6b2203d61fff.svg";
export { ForwardRef as ReactComponent };